module.exports = __webpack_public_path__ + "static/media/onboarding16.3e554308.svg";